import React, { Component, useState, useEffect, useMemo } from "react";
import { defaultTheme } from "react-admin";
import "./App.css";

import authProvider from "./authProvider";
import NewAuthProvider from "./NewAuthProvider";
import { Admin, Resource, EditGuesser, useTranslate } from "react-admin";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import myRestProvider from "./myRestProvider";
import Dashboard from "./dashboard/Dashboard";
import MyLoginPage from "./login_page";
import MyNewLoginPage from "./new_login_page";

import { GetCurrentUserRoles, googleRecaptchaKey, getLocalStorageKey } from "./common/common";
import { ComplaintMenu } from "./common/common";

import polyglotI18nProvider from "ra-i18n-polyglot";

import SapSdoDispute from "./sap_sdo_dispute";
import SapProducts from "./sap_contract_products";
import SapPayers from "./sap_contract_payers";
// import RetailerContracts from './retailer_contracts';
import digitalOrders from "./digitalOrders";
import DigitalOrdersLineItemEdit from "./DigitalOrderLineItems/DigitalOrderLineItemsEdit";
import digitalOrderTrans from "./digitalOrderTrans";
import singleDeliveryOrders from "./singleDeliveryOrders";
import { PostList } from "./proofOfPayments/post";
import { PostEdit } from "./proofOfPayments/post";
import { CreateProofOfPayment } from "./proofOfPayments/create";
import businesses from "./businesses";
// import whitelistUsers from './whiteListUsers1';
import {
  WhiteListUsersList,
  WhiteListUsersEdit,
  WhiteListUsersCreate,
} from "./whiteListUsers/posts";
import TermsConditionsList from "./termsCondition/TermsConditionHistoryList";
import TermsConditionEdit from "./termsCondition/TermsConditionEdit";
import { TermsConditionsChangeLogList } from "./termsCondition/TermsConditionHistory";
import { SettingList } from "./settings";
import { SettingChangeLogList } from "./settings/changeLogList";

import { ChangeLogList } from "./whiteListUsers/changeLogList";
// import PostShow  from './whiteListUsers1/postShow';
import contracts from "./contracts";
import shipTos from "./shipTos";
import clickItUser from "./clickItUser";
import projectsProduct from "./projects";
import sapMaterialsForSdos from "./sapMaterialsForSdos";
// import salesOfficers from './salesOfficersOld'
import salesOfficers from "./salesOfficers";
import businessTargets from "./businessTargets";
import loyaltyPoints from "./loyaltyPoints";
import complaintManagements from "./complaintManagements";
import InAppNotification from "./inAppNotification";
import SoAppNotification from "./soAppNotification";
import SendMessage from "./sendMessage";
import Promotions from "./promotions";
import Surveys from "./survey";
import SoSendMessage from "./soSendMessage";
import BulkInAppNotification from "./bulkInAppNotification";
import BulkSendMessage from "./bulkSendMessage";

import { ProductList } from "./productList";
import { ProductChangeLogList } from "./productList/changeLogList";

import customRoutes from "./customRoutes";
// import en from "./enM";
// import englishKenyaMessages from "./enKEM";

import en from "./i18n/en";
import fr from "./i18n/fr";

import * as Colors from "@mui/material/colors";

import { createTheme } from "@mui/material/styles";
import MyLayout from "./MyLayout";
import NotFound from "./NotFound";
import { BrowserRouter } from "react-router-dom";

import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  loginType,
} from "./common/common";
import probasePayments from "./probasePayments";
import PriceUpdate from "./priceUpdateMadagaskar";
import DiliverySMS from "./diliverySMS/index";
import BulkOrderBlockUpload from "./BulkOrderBlockUpload";
import CreateBusinessOnUpload from "./CreateBusinessOnUpload";
import DashboardBanners from "./dashboardBanners";
import EmailerBanners from "./emailerBanners";
import DashboardBannersWeb from "./dashboardBannersWeb";
import ProductImages from "./productImages";
import clickitProducts from "./clickitProducts";
import loyaltyWithReward from "./loyaltyWithReward";
import rewardSystem from "./rewardSystem";
import UserSignup from './userSignup';
import plants from "./plants";
import rocksPlants from "./rocksPlant";

const ClickitTheme = (baseThemeColor) => ({
  ...defaultTheme,
  typography: {
    fontFamily: ["WorkSans-Medium"].join(","),
  },
  components: {
    ...defaultTheme.components,
    RaAppBar: {
      styleOverrides: {
       root:
      baseThemeColor === 'clickittheme'
        ? {
            backgroundColor: "#53a5ec",
          }
        : {
            backgroundImage: "linear-gradient(45deg, #103776 0%, #01FBFF 100%)",
          },
      },
    },
  },
});

const myTheme = createTheme({
  palette: {
    primary: Colors.lightBlue,
    secondary: Colors.red,
    error: Colors.red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["NeueEinstellung", "Arial", "sans-serif"].join(","),
  },

  overrides: {
    MuiButton: {
      // override the styles of all instances of this component
      root: {
        // Name of the rule
        // color: '#000!important',
        fontSize: "12px!important",
        // background: '#2d88e9!important',
        // padding: '1px 16px!important',
        minHeight: "32px!important",
        borderRadius: "2px!important",
      },

      label: {
        textTransform: "capitalize!important",
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: "1rem!important",
        lineHeight: "inherit!important",
        whiteSpace: "inherit!important",
        height: "inherit!important",
      },
    },
    MuiAppBar: {
      root: {
        background: "#53A5EC!important",
        color: "#ffffff!important",
        position: "absolute",
        // '&:after': {
        //     content: '""',
        //     position: 'absolute',
        //     left: '10px',
        //     top:'3px',
        //     padding:'0',
        //     backgroundImage: 'url(../../../navendor-logo.svg)',
        //     backgroundRepeat: 'no-repeat',
        //     backgroundColor: '#53A5EC',
        //     backgroundPosition:'-120px 14px',
        //     backgroundSize: '148px',
        //     height: '40px',
        //     width: '36px',
        //     display: 'block',
        // }
      },
    },
    MuiToolbar: {
      root: {
        textAlign: "center",
        minHeight: "56px",
      },
      dense: {
        minHeight: "56px",
      },
    },

    MuiCard: {
      root: {
        overflow: "inherit!important",
        overflowY: "auto!important",
      },
    },
    MuiTable: {
      root: {
        overflow: "auto!important",
        width: "100%",
        borderCollapse: "initial!important",
        paddingLeft: "10px",
      },
    },
    MuiInput: {
      root: {
        width: "100%",
      },
      underline: {
        "&:after": {
          borderBottomColor: "#53A5EC",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "rgba(0, 0, 0, 0.54)!important",
        },
      },
    },
    MuiLinearProgress: {
      bar: {
        backgroundColor: "#53A5EC!important",
      },
      colorPrimary: {
        backgroundColor: "#ccc!important",
      },
    },
    MuiTabs: {
      root: {
        marginTop: "40px",
        width: "100%",
      },
      // fixed:{
      //     overflow:'scroll',
      //     background:'#fff',
      // },
      // flexContainer:{
      //     overflow:'scroll',
      // },
      indicator: {
        background: "none",
      },
    },
    MuiTableCell: {
      head: {
        fontSize: "14px!important",
        minWidth: "100px!important",
        fontWeight: "bold!important",
        padding: "10px!important",
        background: "#e3e3e3",
      },
      body: {
        fontSize: "12px!important",
        padding: "10px!important",
        minWidth: "100px!important",
        whiteSpace: "nowrap",
      },
      numeric: {
        textAlign: "left",
        flexDirection: "initial",
      },
    },
    MuiFormControl: {
      marginNormal: {
        // minWidth: '200px!important',
        marginLeft: "5px",
        width: "100%",
      },
    },
    MuiTablePagination: {
      toolbar: {
        width: "90px",
      },
    },
    MuiSvgIcon: {
      root: {
        // fontSize:'20px!important',
      },
    },
    MuiTypography: {
      subheading: {
        whiteSpace: "nowrap",
      },
    },
  },
});

console.log("myTheme", myTheme);

const i18nProvider = polyglotI18nProvider((locale) => {
  console.log("locale......", locale);
  const localStorageLocale = localStorage.getItem("language");
  console.log("localStorageLocale", localStorageLocale);
  if (locale === "en") {
    // initial call, must return synchronously
    return en;
  }
  if (locale === "fr") {
    return fr;
    // return import('./i18n/fr').then(messages => messages.default);
  } else {
    return en;
  }
}, "en");

// const i18nProvider = polyglotI18nProvider((locale) => {
//   let messages = en;
//   switch (locale) {
//     case "en-UG":
//     case "en-KE":
//       messages = englishKenyaMessages;
//       break;
//     default:
//       messages = en;
//       break;
//   }
//   return messages;
// });

const renderResources = (props) => {
  // console.log('ResourceRoleWrapper', props);
  let roleData = GetCurrentUserRoles();
  let complaint = ComplaintMenu();

  console.log("loginType=====>", loginType);
  const resources = [
    <Resource name="businesses" options={{ label: " " }} {...businesses} />,
    <Resource
      name="proof_of_payments"
      list={PostList}
      edit={PostEdit}
      create={CreateProofOfPayment}
      options={{ label: "Proof record" }}
    />,
    <Resource
      name="emailer_banners"
      {...EmailerBanners}
      options={{ label: "Emailer Banner" }}
    />,
    <Resource
      name="dashboard_banners"
      {...DashboardBanners}
      options={{ label: "Dashboard Banner" }}
    />,
    <Resource
      name="dashboard_banners_web"
      {...DashboardBannersWeb}
      options={{ label: "Dashboard Banner Web" }}
    />,
    <Resource
      name="productsmaster"
      {...ProductImages}
      options={{ label: "Product Images" }}
    />,
    <Resource
      name="clickit_products"
      {...clickitProducts}
      options={{ label: "Clickit Products" }}
    />,
    <Resource
      name="sap_digital_orders"
      options={{ label: "All orders viewed via app" }}
      {...digitalOrders}
    />,
    <Resource
      name="sap_digital_order_line_items"
      options={{ label: "Line Items" }}
      edit={DigitalOrdersLineItemEdit}
    />,
    <Resource
      name="digital_order_transactions"
      options={{ label: "Digital Order Transactions" }}
      {...digitalOrderTrans}
    />,
    <Resource
      name="sap_digital_app_orders"
      options={{ label: " " }}
      {...digitalOrders}
    />,
    <Resource name="sap_digital_order_line_items" options={{ label: " " }} />,
    <Resource
      name="sap_digital_disputed_orders"
      options={{ label: "Disputed Orders" }}
      {...digitalOrders}
    />,
    <Resource
      name="received_digital_orders"
      options={{ label: "Received Digital Orders" }}
      {...digitalOrders}
    />,
    <Resource
      name="sap_contracts"
      options={{ label: "Contracts" }}
      {...contracts}
    />,
    <Resource
      name="sap_sdo_dispute"
      options={{ label: "Delivery Dispute" }}
      show={SapSdoDispute}
    />,
    <Resource
      name="sap_contract_products"
      options={{ label: "Products" }}
      show={SapProducts}
    />,
    <Resource
      name="sap_contract_payers"
      options={{ label: "Payers" }}
      show={SapPayers}
    />,
    <Resource
      name="sap_business_sites"
      options={{ label: "Ship-To Sites" }}
      {...shipTos}
    />,
    <Resource
      name="sms_delivery_reports"
      options={{ label: "sms_reports" }}
      list={DiliverySMS}
    />,
    <Resource
      name="sap_sdo_for_orders"
      options={{ label: " " }}
      {...singleDeliveryOrders}
    />,
    <Resource
      name="sap_materials_for_sdos"
      options={{ label: "SDO Materials" }}
      {...sapMaterialsForSdos}
    />,
    <Resource
      name="sales_officers"
      options={{ label: "Sales Officers" }}
      {...salesOfficers}
    />,
    <Resource
      name="business_targets"
      options={{ label: "Targets" }}
      {...businessTargets}
    />,
    <Resource
      name="loyalty_points"
      options={{ label: "Loyalty Points" }}
      {...loyaltyPoints}
    />,
    <Resource
      name="probase_payments"
      options={{ label: "Probase Payments" }}
      {...probasePayments}
    />,
    <Resource
      name="in_app_notifications"
      options={{ label: "Notification" }}
      {...InAppNotification}
    />,
    <Resource
      name="so_in_app_notifications"
      options={{ label: "So Notification" }}
      {...SoAppNotification}
    />,
    <Resource
      name="sms_blasts"
      options={{ label: "Marketing" }}
      {...SendMessage}
    />,
    <Resource
      name="so_sms_blasts"
      options={{ label: "So Marketing" }}
      {...SoSendMessage}
    />,
    <Resource
      name="in_app_sold_to_list"
      options={{ label: "Sold To List" }}
      {...InAppNotification}
    />,
    <Resource
      name="surveys_sold_to_list"
      options={{ label: "Sold To List" }}
      {...Surveys}
    />,
    <Resource
      name="so_in_app_sold_to_list"
      options={{ label: "So Notification" }}
      {...SoAppNotification}
    />,
    <Resource
      name="terms_and_condition_list"
      list={TermsConditionsList}
      options={{
        label: props("resources.terms_and_condition_list.fields.terms"),
      }}
    />,
    <Resource
      name="term_and_conditions"
      list={TermsConditionEdit}
      options={{
        label: props(
          "resources.terms_and_condition_list.fields.terms_condition"
        ),
      }}
    />,
    <Resource
      name="sms_blast_sold_to_list"
      options={{ label: "Sold To List" }}
      {...SendMessage}
    />,
    <Resource
      name="promotions"
      options={{ label: "Promotion Notifications" }}
      {...Promotions}
    />,
    <Resource
      name="surveys"
      options={{ label: "Survey Notifications" }}
      {...Surveys}
    />,
    <Resource name="survey_targeted_features" />,
    <Resource
      name="promotion_sold_to_list"
      options={{ label: "Promotion Sold To List" }}
      {...Promotions}
    />,
    <Resource
      name="so_sms_blast_sold_to_list"
      options={{ label: "So Sold To List" }}
      {...SoSendMessage}
    />,
    <Resource
      name="send_bulk_notifications"
      options={{ label: "Bulk Notification" }}
      {...BulkInAppNotification}
    />,
    <Resource
      name="bulk_notification_sold_to_list"
      options={{ label: "Bulk Sold To List" }}
      {...BulkInAppNotification}
    />,
    <Resource
      name="send_sms_bulk_notifications"
      options={{ label: "Bulk Message" }}
      {...BulkSendMessage}
    />,
    <Resource
      name="send_sms_bulk_sold_to_list"
      options={{ label: "Bulk Message" }}
      {...BulkSendMessage}
    />,
    // <Resource name="complaints" options={{ label: 'Complaint Management' }} {...complaintManagements} />,
    <Resource
      {...props}
      name="sap_contracts_product_list"
      list={ProductList}
      options={{ label: "Product list" }}
    />,
    <Resource
      name="track_logs_history"
      list={ProductChangeLogList}
      options={{ label: "track_logs_history" }}
    />,
    // <Resource name="sap_plants" />,
    <Resource name="getSapDetails" />,
    <Resource
      name="track_trems_logs_history"
      list={TermsConditionsChangeLogList}
      options={{ label: "track_trems_logs_history" }}
    />,
    <Resource
      name="madagascar_products_list"
      {...PriceUpdate}
      options={{ label: "Price Update" }}
    />,
    <Resource
      name="order_block_create"
      list={BulkOrderBlockUpload}
      options={{ label: "Ordering Blocked Upload" }}
    />,
    <Resource
      name="create_business_from_csv"
      list={CreateBusinessOnUpload}
      options={{ label: "Create Business from csv" }}
    />,
    <Resource name="users" options={{ label: " " }} {...clickItUser} />,
    <Resource name="projects" options={{ label: " " }} {...projectsProduct} />,
    <Resource
      name="business_projects"
      options={{ label: " " }}
      {...projectsProduct}
    />,
    <Resource
      name="business_contracts"
      options={{ label: " " }}
      {...projectsProduct}
    />,
    // <Resource name="users" options={{ label: " " }} {...clickItUser} />,
    <Resource
      name="get_user_contracts"
      options={{ label: " " }}
      {...clickItUser}
    />,
    <Resource
      name="user_loyalty_points"
      options={{ label: " " }}
      {...loyaltyWithReward}
    />,
    <Resource
      name="user_loyalty_points"
      options={{ label: " " }}
      {...clickItUser}
    />,
    <Resource
      name="loyalty_rewards"
      options={{ label: " " }}
      {...rewardSystem}
    />,
    <Resource
      name="clickit_signup_customers"
      options={{ label: " " }}
      {...UserSignup}
    />,
    <Resource name="sap_plants" options={{ label: " " }} {...plants} />,
    <Resource
      name="rocks_plants"
      options={{ label: " " }}
      {...rocksPlants}
    />,
  ];
  if (roleData && (roleData[0] === "$ca" || roleData[0] === "$csa")) {
    resources.push(
      <Resource
        {...props}
        name="whitelist_users"
        create={WhiteListUsersCreate}
        edit={WhiteListUsersEdit}
        list={WhiteListUsersList}
        options={{
          label: props("resources.whitelist_users.fields.whitelist_user"),
        }}
      />
    );
    resources.push(
      <Resource
        name="change_log"
        list={ChangeLogList}
        options={{ label: "change_log" }}
      />
    );
  }
  if (roleData && roleData[0] === "$csa") {
    resources.push(
      <Resource
        {...props}
        name="settings"
        list={SettingList}
        options={{ label: "settings" }}
      />
    );
    resources.push(
      <Resource
        name="settings_change_log"
        list={SettingChangeLogList}
        options={{ label: "settings_change_log" }}
      />
    );
  }
  // if (roleData && roleData[0] === '$ca') {
  //     resources.push(<Resource name="settings" options={{ label: 'Settings' }} list={SettingList} />)
  //     resources.push(<Resource name="settings_change_log" list={SettingChangeLogList} options={{ label: 'settings Change Log' }} />)
  // }
  if (complaint) {
    resources.push(
      <Resource
        name="complaints"
        options={{ label: "Complaint Management" }}
        {...complaintManagements}
      />
    );
  }
  return resources;
};

// class App extends Component {
//   setupInterval = (callback, interval, name) => {
//     var key = "_timeInMs_" + (name || "");
//     var now = Date.now();
//     var timeInMs = localStorage.getItem(key);
//     var executeCallback = function () {
//       localStorage.setItem(key, Date.now());
//       callback();
//     };
//     if (timeInMs) {
//       // User has visited
//       var time = parseInt(timeInMs);
//       var delta = now - time;
//       if (delta > interval) {
//         // User has been away longer than interval
//         setInterval(executeCallback, interval);
//       } else {
//         // Execute callback when we reach the next interval
//         setTimeout(function () {
//           setInterval(executeCallback, interval);
//           executeCallback();
//         }, interval - delta);
//       }
//     } else {
//       setInterval(executeCallback, interval);
//     }
//     localStorage.setItem(key, now);
//   };

//   render() {
//     return (
//       <React.Fragment>
//         {loginType === "password_based" ? (
//           <GoogleReCaptchaProvider
//             reCaptchaKey={googleRecaptchaKey}
//             language="en"
//             useRecaptchaNet="true"
//           >
//             <Admin
//               loginPage={MyNewLoginPage}
//               catchAll={NotFound}
//               i18nProvider={i18nProvider}
//               layout={MyLayout}
//               theme={myTheme}
//               dashboard={Dashboard}
//               authProvider={NewAuthProvider}
//               dataProvider={myRestProvider}
//               title=""
//               customRoutes={customRoutes}
//             >
//               {renderResources}
//             </Admin>
//           </GoogleReCaptchaProvider>
//         ) : (
//           <Admin
//             loginPage={MyLoginPage}
//             catchAll={NotFound}
//             i18nProvider={i18nProvider}
//             layout={MyLayout}
//             theme={myTheme}
//             dashboard={Dashboard}
//             authProvider={authProvider}
//             dataProvider={myRestProvider}
//             title=""
//           >
//             {renderResources}
//           </Admin>
//         )}
//       </React.Fragment>
//     );
//   }
// }
// export default App;

const App = () => {
  const locale = localStorage.getItem("language");
  const localStorageAppType = getLocalStorageKey("app_type");
  const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");

  // useEffect(() => {
  //   if (localStorageAppType === "HOLCIM") {
  //     setBaseThemeColor("holcimtheme");
  //   } else {
  //     setBaseThemeColor("clickittheme");
  //   }
  // }, [localStorageAppType]);

useEffect(() => {
  const interval = setInterval(() => {
    const appType = localStorage.getItem("app_type");

    // console.log(appType, "localStorageAppType");

    if (appType) {
      if (appType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
        document.title = "HOLCIM+ Admin Dashboard";
        const favicon = document.getElementById("favicon");

        if (favicon) {
        favicon.href = "/favicon2.ico";
        }
      } else {
        setBaseThemeColor("clickittheme");
         document.title = "Clickit Admin Dashboard";
        const favicon = document.getElementById("favicon");
        if (favicon) {
        favicon.href = "/favicon.ico";
        }
      }

      // Stop checking once app_type is available
      clearInterval(interval);
    }
  }, 50);

  // Cleanup if the component unmounts
  return () => clearInterval(interval);
}, []);

  // Create theme object from current state
  const theme = useMemo(
    () => ClickitTheme(baseThemeColor),
    [baseThemeColor]
  );

  const translate = useTranslate();

  const setupInterval = (callback, interval, name) => {
    var key = "_timeInMs_" + (name || "");
    var now = Date.now();
    var timeInMs = localStorage.getItem(key);
    var executeCallback = function () {
      localStorage.setItem(key, Date.now());
      callback();
    };
    if (timeInMs) {
      // User has visited
      var time = parseInt(timeInMs);
      var delta = now - time;
      if (delta > interval) {
        // User has been away longer than interval
        setInterval(executeCallback, interval);
      } else {
        // Execute callback when we reach the next interval
        setTimeout(function () {
          setInterval(executeCallback, interval);
          executeCallback();
        }, interval - delta);
      }
    } else {
      setInterval(executeCallback, interval);
    }
    localStorage.setItem(key, now);
  };

  return (
    <>
      {loginType === "password_based" ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={googleRecaptchaKey}
          language="en"
          useRecaptchaNet="true"
        >
          <BrowserRouter>
            <Admin
              loginPage={MyNewLoginPage}
              locale={locale}
              catchAll={NotFound}
              i18nProvider={i18nProvider}
              layout={MyLayout}
              // theme={myTheme}
              theme={theme}
              dashboard={Dashboard}
              authProvider={NewAuthProvider}
              dataProvider={myRestProvider}
              title=""
              customRoutes={customRoutes}
            >
              {renderResources(translate)}
            </Admin>
          </BrowserRouter>
        </GoogleReCaptchaProvider>
      ) : (
        <BrowserRouter>
          <Admin
            loginPage={MyLoginPage}
            catchAll={NotFound}
            locale={locale}
            i18nProvider={i18nProvider}
            layout={MyLayout}
            // theme={myTheme}
            theme={theme}
            dashboard={Dashboard}
            authProvider={authProvider}
            dataProvider={myRestProvider}
            title=""
          >
            {renderResources(translate)}
          </Admin>
        </BrowserRouter>
      )}
    </>
  );
};
export default App;
